<template>
    <Frame>
        <PageHeader :title="$t('salDispatchListDetail.orderDetail')" :hasBack="true" />
        <div class="header-contain" ref="headContain">
            <div class="title-row">
                <span>{{ $t('comm.messagetitle') }}</span>
            </div>
            <div class="head-fields">
                <div class="field">{{ $t('salDispatchListDetail.BillNo') + BillNo }}</div>
                <div class="field">{{ $t('salDispatchListDetail.BillDate') + BillDate }}</div>
                <div class="field">{{ $t('salDispatchListDetail.BizPartnerName') + BizPartnerName }}</div>
                <div class="field">{{ $t('salDispatchListDetail.OAmount') + OAmount + CurrId }}</div>
                <div class="field">{{ $t('salDispatchListDetail.Remark') + Remark }}</div>
                <div class="field">{{ $t('salDispatchListDetail.CurrentState') + CurrentState }}</div>
                <div class="field">{{ $t('salDispatchListDetail.PermitState') + PermitState }}</div>
            </div>
            <div class="title-row" style="margin:16px 0">
                <span>{{ $t('comm.detailtitle') }}</span>
            </div>
        </div>
        <el-table :data="tableData" style="margin:0;width:100%;color:#777777;font-size:14px;" :height="tableHeight"
            v-loading="tableLoading">
            <el-table-column prop="RowNo" width="60" :label="$t('salDispatchListDetail.RowNo')"></el-table-column>
            <el-table-column prop="CU_X_CustNumberOrg" :width="WidthControl('CU_X_CustNumberOrg', tableData)" :label="$t('salSalesOrder.customerNo')"></el-table-column>
            <el-table-column prop="FromOrderBillNo" :width="WidthControl('FromOrderBillNo', tableData)" :label="$t('salDispatchListDetail.orderBillNo')"></el-table-column>
            <el-table-column prop="X_BPMaterialId" :width="WidthControl('X_BPMaterialId', tableData)" label="ItemCode"></el-table-column>
            <el-table-column prop="X_BPMaterialName" :min-width="WidthControl('X_BPMaterialName', tableData)" label="ItemName"></el-table-column>
            <el-table-column :width="WidthControl('X_LUnitName', tableData,4)" :label="$t('orderImport.lengthUnit')">
                <template slot-scope="scope">
                    <span>{{ scope.row.X_LUnitName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="SQuantity" :label="$t('salDispatchListDetail.SQuantity')" :width="WidthControl('SQuantity&&SUnitName', tableData,4)">
                <template slot-scope="scope">
                    <span>{{ scope.row.SQuantity }}&nbsp{{ scope.row.SUnitName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="TotalSQty" :label="$t('salDispatchListDetail.TotalSQty')" :width="WidthControl('TotalSQty', tableData,4)">
            </el-table-column>
            <el-table-column prop="InventoryState" :label="$t('salDispatchListDetail.InventoryState')" :width="WidthControl('InventoryState', tableData,4)">
            </el-table-column>
            <el-table-column prop="BatchNo" :label="$t('salDispatchListDetail.batchNo')" :width="WidthControl('BatchNo', tableData,4)">
            </el-table-column>
        </el-table>
    </Frame>
</template>
<script>
import { detailMixin } from '@/agency/mixin/mixin'
export default {
    mixins: [detailMixin],
    data() {
        return {
            BillDate: '',
            BizPartnerName: '',
            OAmount: '',
            Remark: '',
            CurrentState: '',
            PermitState: '',
            CurrId: '',
        }
    },
    props: {
        GetOrderDetail: {
            type: Function,
            default: function () {
                this.getOrderDetail();
            }
        }
    },
    mounted() {
        //因为需要计算表头高度，所以要拿到ref以后才可以去计算高度，所以要放在mounted上，提前钩子到created会有高度计算bug
        this.GetOrderDetail();
    },
    methods: {
        getOrderDetail() {
            this.tableLoading = true;
            this.axiosInvoke(this.sysHandlerUrl, {
                action: 'getsaldispatchlistdetail',
                BillNo: this.BillNo
            }, (res, err) => {
                if (!err) {
                    const data = res.data;
                    const headTable = data.headTable;
                    this.tableLoading = false;
                    this.BillDate = headTable.BillDate;
                    this.BizPartnerName = headTable.BizPartnerName;
                    this.OAmount = headTable.masterStrPrice;
                    this.Remark = headTable.Remark;
                    this.CurrentState = headTable.CurrentState;
                    this.PermitState = headTable.PermitState;
                    this.CurrId = headTable.CurrId;
                    this.tableData = data.bodyTable;

                    //二开本方法时，请记得带上下面这段页面resize监听代码
                    this.$nextTick(() => {
                        this.frameOnResize(150);
                    })
                }

            })
        }
    }
}
</script>
<style scoped>
.header-contain {
    display: flex;
    padding: 0 30px;
    width: calc(100% - 60px);
    padding-top: 38px;
    flex-wrap: wrap;
}

.title-row {
    color: #5d5d5d;
    font-size: 16px;
    width: 20%;
    display: flex;
    justify-content: space-between;
    width: 100%;

}

.fun-buttons {
    width: 40%;
    display: flex;
    justify-content: flex-end;
    padding-right: 10%;
}

.button {
    color: #5d5d5d;
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
}

.button:hover {
    cursor: pointer;
    color: #0177d5;
}

.option-icon {
    filter: grayscale(100%);
    margin: 0 2.5%;
}

.option-icon:hover {
    filter: grayscale(0%);
}

.field {
    color: #777;
    font-size: 14px;
    width: 24%;
    padding-top: 14px;
    margin-right: 1%;
    word-break: break-all;
    max-height: 150px;
    overflow: auto;
}

.head-fields {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}

.el-table /deep/ .el-table__body-wrapper {
    font-size: 13px;
}

.el-table /deep/ thead {
    font-size: 14px;
    color: #777777;
}

.el-table /deep/ .el-table_1_column_1 .cell:first-child {
    padding: 0 0 0 30px;
}

.el-table /deep/ .cell:first-child {
    font-weight: normal;
}
</style>
